
/**
   * Returns an message based the error code.
   * @param {String} errorCode Any error that occurred when determining authentication status. An empty string if none..
   * @param {String} detailedErrorMessage The message is passed by Adobe Primetime authentication through this callback to the Programmer's site.
   */
export default function getErrorMessage(errorCode, detailedErrorMessage) {
  if (detailedErrorMessage) {
    return detailedErrorMessage;
  }
  let message = '';
  switch (errorCode) {
    case 'User Not Authenticated Error':
      message = 'Sorry, your login is invalid. Please try again.';
      break;
    case 'Provider Not Selected Error':
      message = 'Sorry, your TV service provider cannot be found.';
      break;
    case 'Generic Authentication Error':
      message = 'Sorry, your login wasn`t recognized. Please try again.';
      break;
    case 'Handled User Not Authorized Error':
    case 'User Not Authorized Error':
    case 'Generic Authorization Error':
    default:
      message = 'Sorry, you are not authorized to view this content. Please call your service provider.'; // eslint-disable-line max-len
      break;
  }

  return message;
}
